import { render, staticRenderFns } from "./RegionalVaccinationRecord.vue?vue&type=template&id=3949a5f8&scoped=true&"
import script from "./RegionalVaccinationRecord.vue?vue&type=script&lang=js&"
export * from "./RegionalVaccinationRecord.vue?vue&type=script&lang=js&"
import style0 from "./RegionalVaccinationRecord.vue?vue&type=style&index=0&id=3949a5f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3949a5f8",
  null
  
)

export default component.exports